import React, { FC } from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { useTranslation } from '$hooks';
import { BasketUsp } from '../basket-usp';
import { formatPrice, formatString } from '$lib/helpers';
import { Flex } from '$components/layouts';

type DeliveryUspProps = {
    value?: number;
    limit?: number;
};

export const DeliveryUsp: FC<DeliveryUspProps> = ({ value = 0, limit = 0 }: DeliveryUspProps) => {
    const { translate } = useTranslation();
    const theme = useTheme();

    return (
        <BasketUsp bgColor={theme.colors.checkoutGreenLight} icon="house">
            <Flex column flex>
                <div>
                    {`${formatString(
                        translate('checkout.checkoutBasket.deliveryFreeHeader'),
                        formatPrice(value) || ''
                    )} `}
                    <UspBoldText>{translate('checkout.checkoutBasket.deliveryFreeText')}</UspBoldText>
                    {` ${translate('checkout.checkoutBasket.deliveryFreeSubHeader')}`}
                </div>
                <StyledProgress value={limit - value} max={limit} />
            </Flex>
        </BasketUsp>
    );
};

const StyledProgress = styled.progress(({ theme }) => ({
    appearance: 'none',
    border: 'none',
    marginTop: theme.space[2],
    width: '100%',
    height: '5px',
    borderRadius: '20px',
    color: theme.colors.checkoutGreen,
    backgroundColor: theme.colors.white,

    '::-webkit-progress-bar': {
        backgroundColor: theme.colors.white,
        borderRadius: '20px',
    },
    '::-webkit-progress-value': {
        backgroundColor: theme.colors.checkoutGreen,
        borderRadius: '20px',
    },
    '::-moz-progress-bar': {
        backgroundColor: theme.colors.checkoutGreen,
        borderRadius: '20px',
    },
}));

const UspBoldText = styled.strong(({ theme }) => ({
    color: theme.colors.checkoutGreen,
    fontWeight: theme.fontWeights.ultraBold,
    textTransform: 'uppercase',
}));
